<script setup>
const props = defineProps({
  fill: {
    type: String,
    default: "currentColor",
  },
});
</script>
<template>
  <svg
      width="21"
      height="12"
      viewBox="0 0 21 12"
      class="-rotate-90"
      :fill="props.currentColor"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 7.18488L2.56775 0L0 2.52241L10.4869 12L21 2.52241L18.4454 0L10.5 7.18488Z"
        :fill="props.currentColor"
    />
  </svg>
</template>
